module.exports = __webpack_public_path__ + "static/media/143-norway.26f044de.svg";